import { DomainName } from "@/sites/domains";
import { GTM_EVENT, GTM_EVENT_NAME, GTM_EVENT_SOURCE } from "@/internals/constants/events";
import { SSO_PROVIDER, type SsoProviderId } from "@/components/SSOAuthButton/types";

export const getGTMId = (siteDomain: string) => {
  switch (siteDomain) {
    case DomainName.QRCreator:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_QRCREATOR;
    case DomainName.FastQRGenerator:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_FASTQRGENERATOR;
    case DomainName.OnlineQRCode:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_ONLINEQRCODE;
    case DomainName.QRNow:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_QRNOW;
    default:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_QRCREATOR;
  }
};

export const pushSignUpCompletedEvent = (params: {
  userId: string;
  email: string;
  source?: string;
  ssoProvider?: SsoProviderId;
}) => {
  const AUTH_SOURCE_MAP: Partial<Record<SsoProviderId, GTM_EVENT_SOURCE>> = {
    [SSO_PROVIDER.APPLE]: GTM_EVENT_SOURCE.APPLE_SSO,
    [SSO_PROVIDER.GOOGLE]: GTM_EVENT_SOURCE.GOOGLE_SSO,
  };

  const authSource = params.ssoProvider ? AUTH_SOURCE_MAP[params.ssoProvider] : undefined;

  window?.dataLayer?.push({
    event: GTM_EVENT_NAME.SIGN_UP_COMPLETED,
    source: params.source,
    "user-id": params.userId,
    email: params.email,
    ...(authSource && { auth_source: authSource }),
    ...(params.ssoProvider && { registration_method: "sso" }),
  } as GTM_EVENT);
};
